import { render, staticRenderFns } from "./SmsMessageContainer.vue?vue&type=template&id=2c2eae80"
import script from "./SmsMessageContainer.vue?vue&type=script&lang=js"
export * from "./SmsMessageContainer.vue?vue&type=script&lang=js"
import style0 from "./SmsMessageContainer.vue?vue&type=style&index=0&id=2c2eae80&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports